<div class="steps-main-container">
    <div class="steps-empty-container">
        <div *ngFor="let step of stepsArray; let i = index" class="step grey"
            [style.backgroundColor]="colorStepGrey"
            [style.width]="step.width">
        </div>
    </div>
    
    <div class="steps-container">
        <div *ngFor="let step of stepsArray; let i = index" class="step" [ngClass]="step.status"
            [style.backgroundColor]="step.status === 'before' && colorStepBefore ? colorStepBefore : (step.status === 'after' && colorStepAfter ? colorStepAfter : null)"
            [style.width]="step.width"
            [style.clipPath]="step.fractionalPart < 1 && step.fractionalPart > 0 ? calculateClipPath(step.fractionalPart) : null">
        </div>
    </div>
</div>